<template>

  <div class="app-preloader fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center z-50">
    <div class=" absolute right-1/2 bottom-1/2  transform translate-x-1/2 translate-y-1/2">
      <div style="border-top-color:transparent; border-right-color:transparent; border-bottom-color:transparent;"
           class="border-solid animate-spin  rounded-full border-priceColor border-8 h-48 w-48 opacity-100 z-50"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-spinner'
}
</script>

<style scoped>
.app-preloader:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(163, 163, 163, 0.4);
}
</style>
